// cf https://weichie.com/ 
// Filter news

if (
  window.location.pathname.includes("news") ||
  window.location.pathname.includes("careers")
) {
  let protocol = window.location.protocol;
  let baseUrl = window.location.host;
  let url = "";
  let page = "";
  let postType = "";

  function findcurrentPostType(page) {
    if (page.includes("news")) {
      postType = "post";
    } else if (page.includes("careers")) {
      postType = "careers";
    } else {
      postType = undefined;
    }
  }

  if (baseUrl.includes("wpo") || baseUrl.includes("nervous")) {
    // On est en preprod ou en prod
    url = protocol + "//" + baseUrl;
    page = window.location.pathname;
    findcurrentPostType(page);
  } else {
    // On est en local
    url = protocol + "//" + baseUrl;
    page = window.location.pathname;
    page = page.replace("wpo/", "");
    findcurrentPostType(page);
  }

  // console.log('post type = ' + postType);

  // On récupère le noeud d'affichage des actus
  let newsList = document.querySelector(".publication-list");

  // On récupère le bouton load more et on prévoit d'autres déclencheurs
  let loadmoreAction = document.querySelectorAll(".loadmore");

  // On récupère le bouton loadmore pour l'afficher ou le masquer suivant la pagination
  let loadmoreButton = document.querySelector("#load-more");

  // On récupère les catégories
  let linkCategories = document.querySelectorAll(".cat-list_item");

  // On initialise la pagination et la catégorie 'toutes' par défaut
  let currentPage = 1;
  let category = "";

  // Si l'on clique sur la catégorie
  linkCategories.forEach((index) => {
    // On passe la catégorie au bouton load more lorsque celle-ci est cliquée
    index.addEventListener("click", (e) => {

      let useCase = "init";

      let category = e.currentTarget.dataset.slug;
      currentPage = 1;

      loadmoreAction.forEach((el) => {
        el.dataset.slug = category;
      });

      fetchNews(category, currentPage, postType, useCase);
    });
  });

  // Si on clique sur le bouton
  loadmoreAction.forEach((index) => {
    index.addEventListener("click", (e) => {

      // On sélectionne le cas pour le fetch et on incrémente la pagination
      let useCase = "add";
      currentPage++;
      const domEl = e.currentTarget;

      // On récupère la catégorie -> toutes
      let category = domEl.getAttribute("data-slug");

      fetchNews(category, currentPage, postType, useCase);
    });
  });

  function fetchNews(category, currentPage, postType, useCase) {
    fetch(url + "/wp-admin/admin-ajax.php", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache",
        Accept: "application/json",
      },
      body: new URLSearchParams({
        action: "load_more",
        category: category,
        paged: currentPage,
        postType: postType,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Dois-je réafficher le bouton Loadmore
        function displayLoadmore() {
          if (currentPage >= data.max) {
            
            loadmoreButton.classList.remove("d-block");
            loadmoreButton.classList.add("d-none");
          } else {
            loadmoreButton.classList.remove("d-none");
            loadmoreButton.classList.add("d-block");
          }
        }

        // Cas on clique sur le bouton loadmore
        if (useCase === "add") {
          newsList.insertAdjacentHTML("beforeEnd", data.html);
          displayLoadmore();
        }

        // Cas où on relance la requête avec une catégorie
        else if (useCase === "init") {
          newsList.innerHTML = data.html;
          displayLoadmore();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
}

